/**
 * landing-icons.ts — mapper ikon-ID (LandingIconId) til Carbon-piktogrammer
 *
 * ibm.com bruker pictograms i produktkort; samme gjør vi her. Eksportnavnene
 * er verifisert mot @carbon/pictograms-react (mappe lib/<navn>/).
 */

import {
  AccessManagement,
  Ai,
  Analytics,
  Building,
  Calendar,
  Colors,
  CustomerService,
  DataBackup,
  DataSecurity,
  Database,
  Folder,
  Group,
  KeyUsers,
  Envelope,
  Notifications,
  Servers,
  Speedometer,
  Websites,
} from '@carbon/pictograms-react';
import type { ComponentType } from 'react';
import type { LandingIconId } from '@/types/landing';

type CarbonPictogram = ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;

export const LANDING_ICONS: Record<LandingIconId, CarbonPictogram> = {
  files: Folder,
  rental: Calendar,
  ads: Analytics,
  crm: Group,
  admin: KeyUsers,
  ai: Ai,
  access: AccessManagement,
  tenant: Building,
  realtime: Notifications,
  theme: Colors,
  speed: Speedometer,
  security: DataSecurity,
  backup: DataBackup,
  support: CustomerService,
  database: Database,
  domain: Websites,
  mail: Envelope,
  server: Servers,
};
